import { Component, OnInit } from '@angular/core';
import { MaintenanceMessageFetchService } from './maintenance.message.service';

import { MaintenanceMessageModalService } from './maintenance.message.modal.service';

@Component({
  selector: 'app-maintenance-message',
  templateUrl: './maintenance.message.modal.pug',
  styleUrls: ['./maintenance.message.modal.sass']
})
export class MaintenanceMessageModalComponent implements OnInit {

  ngOnInit(): void {
    this.fetchMessage();
  }

  constructor(
    private messageFetchService: MaintenanceMessageFetchService,
    public modalService: MaintenanceMessageModalService,
  ) {
  }

  private fetchMessage(): void {
    this.messageFetchService
      .getCurrentMessage()
      .then(message => {
        if (message) {
          message.createdByFullName = 'Üzemeltetés';
          this.modalService.message = message;
        }
      })
      .catch(e => {
        console.debug(e);
      })
      ;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maintenance.message.modal/maintenance.message.component.ts